/* RESPONSIBLE TEAM: team-inbox-management */
import moment from 'moment-timezone';

export default class TeammatesCsvExporter {
  constructor(
    app,
    admins,
    { workspaceAssignmentLimit, workspaceTicketAssignmentLimit, teamInboxes, teamSettings, intl },
  ) {
    this.app = app;
    this.admins = admins;
    this.workspaceAssignmentLimit = workspaceAssignmentLimit;
    this.workspaceTicketAssignmentLimit = workspaceTicketAssignmentLimit;

    this.teamInboxes = teamInboxes;
    this.teamSettings = teamSettings;
    this.intl = intl;
  }

  get filename() {
    return this.intl.t('settings.teammate-workload.export-csv.filename', {
      date: moment.tz(this.app.timezone).format('YYYY-MM-DD'),
    });
  }

  get data() {
    let data = this.admins.map((admin) => this.row(admin));
    data.unshift(this.headerColumn);

    return data;
  }

  row(admin) {
    let baseColumns = [
      this.name(admin),
      this.email(admin),
      this.role(admin),
      this.assignmentLimit(admin),
    ];

    baseColumns.push(this.ticketAssignmentLimit(admin));
    baseColumns.push(this.primaryInboxes(admin), this.secondaryInboxes(admin));

    return baseColumns;
  }

  name(admin) {
    return admin.name;
  }

  email(admin) {
    return admin.email;
  }

  role(admin) {
    return (
      admin.currentAppPermissions?.role?.name ||
      this.intl.t('settings.teammate-workload.export-csv.no-role')
    );
  }

  assignmentLimit(admin) {
    return (
      admin.workload_management_settings?.assignment_limit?.toString() ||
      `${this.workspaceAssignmentLimit} (${this.intl.t('settings.teammate-workload.export-csv.workspace-conversation-limit')})` ||
      this.intl.t('settings.teammate-workload.export-csv.no-limit')
    );
  }

  ticketAssignmentLimit(admin) {
    return (
      admin.workload_management_settings?.ticket_assignment_limit?.toString() ||
      `${this.workspaceTicketAssignmentLimit} (${this.intl.t(
        'settings.teammate-workload.export-csv.workspace-ticket-limit',
      )})` ||
      this.intl.t('settings.teammate-workload.export-csv.no-limit')
    );
  }

  primaryInboxes(admin) {
    return this.teamInboxes
      .filter((inbox) => inbox.primaryMembers.includes(parseInt(admin.id, 10)))
      .map((inbox) => inbox.name)
      .join(', ');
  }

  secondaryInboxes(admin) {
    return this.teamInboxes
      .filter((inbox) => this.teamSettingByTeamId(inbox.id)?.distributionMethod === 'load_balanced')
      .filter((inbox) => inbox.secondaryMembers.includes(parseInt(admin.id, 10)))
      .map((inbox) => inbox.name)
      .join(', ');
  }

  teamSettingByTeamId(teamId) {
    return this.teamSettings.find((teamSetting) => teamSetting.teamId === teamId);
  }

  get headerColumn() {
    let headers = [
      this.intl.t('settings.teammate-workload.export-csv.name'),
      this.intl.t('settings.teammate-workload.export-csv.email'),
      this.intl.t('settings.teammate-workload.export-csv.role'),
    ];

    headers.push(
      this.intl.t('settings.teammate-workload.export-csv.conversation-assignment-limit'),
      this.intl.t('settings.teammate-workload.export-csv.ticket-assignment-limit'),
    );

    headers.push(
      this.intl.t('settings.teammate-workload.export-csv.primary-inboxes'),
      this.intl.t('settings.teammate-workload.export-csv.secondary-inboxes'),
    );

    return headers;
  }
}
